import {
  MIN_WIDTH_DESKTOP,
  useMediaQuery,
} from '@porterin/feature/src/shared/core/hooks/useMediaQuery';
import { CommonImage } from '@porterin/feature/src/shared/types/CommonVM';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React from 'react';

import styles from '../styles/VehicleCapacity.module.scss';

interface VehicleCapacityCmpProps {
  icon: CommonImage;
  capacity: string;
}

function VehicleCapacityCmp({
  icon,
  capacity,
}: Readonly<VehicleCapacityCmpProps>): React.ReactElement {
  const isDesktop = useMediaQuery(MIN_WIDTH_DESKTOP);

  return (
    <div className={styles['vehicle-capacity-container']}>
      <div className={styles['vehicle-capacity-image-wrapper']}>
        <NextImageV2
          width={isDesktop ? 16 : 12}
          height={isDesktop ? 16 : 12}
          src={icon.path}
          alt={icon.alt_text}
          quality={100}
        />
      </div>
      <p className={styles['vehicle-capacity']}>{capacity}</p>
    </div>
  );
}

export default VehicleCapacityCmp;
